import { AxiosResponse } from 'axios';
import ApiConstants from '../../../../core/constants/api_constants';
import { request } from '../../../../core/network/axiosInstance';

export class QuestionCourseApiService {
  private readonly questionCourseBaseUrl: string;

  constructor() {
    this.questionCourseBaseUrl = ApiConstants().questionCourse;
  }

  async getStartQuestionCourse(): Promise<AxiosResponse> {
    return await request({
      url: `${this.questionCourseBaseUrl}type/start`,
      method: 'GET',
      requiresToken: true,
    });
  }

  async getEndQuestionCourse(): Promise<AxiosResponse> {
    return await request({
      url: `${this.questionCourseBaseUrl}type/end`,
      method: 'GET',
      requiresToken: true,
    });
  }
}
